import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Grid } from 'semantic-ui-react';
import AutoServe from 'PointOfSale/modules/servingOptionCategory/component/Autoserve';

const CepTypesSelection = props => {
  const { handleCepTypeChange, types, selectedCepType } = props;
  return (
    <React.Fragment>
      <Grid.Column>
        <div className="text-center text-primary">
          <label>Select Type</label>
        </div>
        <Dropdown
          className="servingOpton-dropdown"
          placeholder="Please select type"
          selection
          options={types}
          size="large"
          fluid
          value={selectedCepType.Id}
          onChange={handleCepTypeChange}
        />
        {selectedCepType.Id === 2 && <AutoServe {...props} />}
      </Grid.Column>
    </React.Fragment>
  );
};

CepTypesSelection.propTypes = {
  quickServeItems: PropTypes.array,
  handleQuickServeItemChange: PropTypes.func,
};

CepTypesSelection.defaultProps = {
  types: [{ key: 'none', value: 'None', text: 'None' }],
};

export default CepTypesSelection;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptionCategory/component/CepTypesSelection.js